/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  formatDate,
  formatTimeString,
  getNewDate,
} from '../../../shared/helper-utils/appUtils';
import { DATE_MONTH_VIEW_FORMAT } from '../../../shared/constants/Constants';
import { useAppContext } from '../../../saas/AppConfigWrapper';

function BusShareCard({
  busOptionsToShare,
  searchRequest,
  showInput,
  showBreakup,
  markUpToBeAdded,
}) {
  const { appConfig } = useAppContext();
  const getAmount = (val) => {
    const markup = markUpToBeAdded === '' ? 0 : parseInt(markUpToBeAdded, 10);
    return parseInt(val, 10) + markup;
  };
  return (
    <div id="busEmailContent">
      <div
        style={{
          width: '750px',
          color: '#000',
          marginLeft: 'auto',
          marginRight: 'auto',
          borderRadius: '10px',
        }}
      >
        <div
          style={{
            padding: '12px',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
            color: '#fff',
            backgroundColor: appConfig?.clientPrimaryColor,
            fontSize: '14px',
          }}
          // className="d-none"
        >
          <table style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td>
                  <b>Origin: </b>
                </td>
                <td>{searchRequest.origin.place_name}</td>
                <td>
                  <b>Destination: </b>
                </td>
                <td>{searchRequest.destination.place_name}</td>
              </tr>
              <tr>
                <td>
                  <b>Journey Date: </b>
                </td>
                <td>
                  {formatDate(
                    getNewDate(searchRequest.jdate),
                    DATE_MONTH_VIEW_FORMAT,
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <table
          style={{
            width: '100%',
            border: '1px solid #ccc',
            borderSpacing: '0',
          }}
        >
          <tbody>
            <tr>
              <td
                style={{
                  fontSize: '10px',
                  fontWeight: '300',
                  padding: '5px',
                  borderBottom: '1px solid #ccc',
                }}
              >
                Operator/Type
              </td>
              <td
                style={{
                  fontSize: '10px',
                  fontWeight: '300',
                  padding: '5px',
                  borderBottom: '1px solid #ccc',
                }}
              >
                Dep Time
              </td>
              <td
                style={{
                  fontSize: '10px',
                  fontWeight: '300',
                  padding: '5px',
                  borderBottom: '1px solid #ccc',
                }}
              >
                Arr Time
              </td>
              <td
                style={{
                  fontSize: '10px',
                  fontWeight: '300',
                  padding: '5px',
                  borderBottom: '1px solid #ccc',
                }}
              >
                Price/seats
              </td>
            </tr>
            {busOptionsToShare.map((d, index) => (
              <tr key={d.nextrabusid}>
                <td
                  style={{
                    borderBottom:
                      index === busOptionsToShare.length - 1
                        ? ''
                        : '1px solid #ccc',
                    padding: '5px',
                  }}
                >
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ fontSize: '14px', fontWeight: '600' }}>
                          {d.operatorname}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontSize: '12px', fontWeight: '400' }}>
                          {d.bustype}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    borderBottom:
                      index === busOptionsToShare.length - 1
                        ? ''
                        : '1px solid #ccc',
                    padding: '5px',
                  }}
                >
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ fontSize: '14px', fontWeight: '600' }}>
                          {formatTimeString(d.deptime)}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontSize: '12px', fontWeight: '400' }}>
                          {d.departuredate !== '' &&
                            d.departuredate !== null &&
                            d.departuredate !== undefined &&
                            formatDate(
                              getNewDate(d.departuredate),
                              DATE_MONTH_VIEW_FORMAT,
                            )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    borderBottom:
                      index === busOptionsToShare.length - 1
                        ? ''
                        : '1px solid #ccc',
                    padding: '5px',
                  }}
                >
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ fontSize: '14px', fontWeight: '600' }}>
                          {formatTimeString(d.arrtime)}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontSize: '12px', fontWeight: '400' }}>
                          {d.arrivaldate !== '' &&
                            d.arrivaldate !== null &&
                            d.arrivaldate !== undefined &&
                            formatDate(
                              getNewDate(d.arrivaldate),
                              DATE_MONTH_VIEW_FORMAT,
                            )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    borderBottom:
                      index === busOptionsToShare.length - 1
                        ? ''
                        : '1px solid #ccc',
                    padding: '5px',
                  }}
                >
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ fontSize: '14px', fontWeight: '600' }}>
                          {showBreakup &&
                            (showInput ? (
                              <span>
                                {appConfig?.appCurrency}{' '}
                                {d.supplierfares[0]?.totalnet}
                              </span>
                            ) : (
                              <span>
                                {appConfig?.appCurrency}{' '}
                                {getAmount(d.supplierfares[0]?.totalnet)}
                              </span>
                            ))}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontSize: '12px', fontWeight: '400' }}>
                          {d.seatdetails?.numseatsavailable} seats left
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div
          style={{
            backgroundColor: '#333333',
            color: '#fff',
            padding: '12px',
            fontSize: '12px',
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
          }}
          // className="d-none"
        >
          <span style={{ fontSize: '14px', marginBottom: '10px' }}>
            Terms & Conditions:
          </span>
          <ul>
            <li>Prices shown are subject to change at the time of booking</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default BusShareCard;

BusShareCard.propTypes = {
  busOptionsToShare: PropTypes.any.isRequired,
  searchRequest: PropTypes.any.isRequired,
  showInput: PropTypes.bool.isRequired,
  showBreakup: PropTypes.bool.isRequired,
  markUpToBeAdded: PropTypes.any.isRequired,
};
